import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Autocomplete } from 'seagull';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import styles from '../GlobalBillingHub.module.scss';
import { getDefaultRelationshipId, getGroupedAgreementOptions } from '../GlobalBillingHub.utils';
export const GlobalBillingHubHeader = (param)=>{
    let { agreements, clientOptions, selectedClient, changeUrlState, groupedOptions, setGroupedOptions, relationshipId } = param;
    var _relationshipOptions_find;
    const { t: headerTexts } = useLocaleKeys('pages.globalBillingHub.header');
    const { t: gbhTexts } = useLocaleKeys('pages.globalBillingHub');
    const isMobileDevice = useIsMobileForHomePage();
    const hasAdHoc = groupedOptions.adHocRelationships.length > 0;
    const hasAgreements = groupedOptions.agreements.length > 0;
    const relationshipOptions = useMemo(()=>[
            ...groupedOptions.agreements,
            ...groupedOptions.adHocRelationships.map((param)=>{
                let { id } = param;
                return {
                    id,
                    text: headerTexts.invoicesWithoutAgreement()
                };
            })
        ], [
        groupedOptions,
        headerTexts
    ]);
    const selectedRelationship = (_relationshipOptions_find = relationshipOptions.find((o)=>o.id === relationshipId)) !== null && _relationshipOptions_find !== void 0 ? _relationshipOptions_find : null;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.filters, {
            [styles.filtersMobile]: isMobileDevice
        }),
        children: [
            /*#__PURE__*/ _jsx(Autocomplete, {
                bi: {
                    name: 'client_search'
                },
                freeSolo: true,
                forcePopupIcon: true,
                className: cn(styles.autocomplete, {
                    [styles.autocompleteMobile]: isMobileDevice
                }),
                testId: "gbh-client",
                options: clientOptions,
                value: selectedClient,
                getOptionLabel: (option)=>option.text,
                textFieldProps: {
                    label: gbhTexts.clientLabel(),
                    placeholder: gbhTexts.chooseClient()
                },
                onChange: (_, newOption)=>{
                    if (!newOption) {
                        changeUrlState({
                            clientId: '',
                            relationshipId: '',
                            selectedDate: ''
                        });
                        setGroupedOptions({
                            agreements: [],
                            adHocRelationships: []
                        });
                    } else if (typeof newOption !== 'string' && !Array.isArray(newOption)) {
                        const newClientId = newOption.id;
                        const grouped = getGroupedAgreementOptions(agreements, newClientId);
                        setGroupedOptions(grouped);
                        changeUrlState({
                            clientId: newClientId,
                            relationshipId: getDefaultRelationshipId([
                                ...grouped.agreements,
                                ...grouped.adHocRelationships
                            ]),
                            selectedDate: ''
                        });
                    }
                }
            }),
            relationshipId && /*#__PURE__*/ _jsx(Autocomplete, {
                bi: {
                    name: 'agreement_filter'
                },
                forcePopupIcon: true,
                className: cn(styles.autocomplete, {
                    [styles.autocompleteMobile]: isMobileDevice
                }),
                testId: "gbh-relationship",
                options: relationshipOptions,
                value: selectedRelationship,
                getOptionLabel: (option)=>option.text,
                textFieldProps: {
                    label: headerTexts.agreementLabel(),
                    placeholder: headerTexts.noAgreements()
                },
                dividers: hasAgreements && hasAdHoc ? [
                    groupedOptions.agreements.length
                ] : undefined,
                onChange: (_, newOption)=>{
                    var _ref;
                    if (typeof newOption === 'string' || Array.isArray(newOption)) return;
                    changeUrlState({
                        relationshipId: (_ref = newOption === null || newOption === void 0 ? void 0 : newOption.id) !== null && _ref !== void 0 ? _ref : '',
                        selectedDate: ''
                    });
                }
            })
        ]
    });
};
